// src/components/ListPrompts.js

import React from "react";
import { useAuth } from "../util/auth";
import { usePromptsByOwner, useEntityTaxonomyByOwner } from "../util/db";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

function ListPrompts() {
  const auth = useAuth();
  const { data: prompts, status: promptsStatus } = usePromptsByOwner(auth.user.uid);
  const { data: bridging, status: bridgingStatus } = useEntityTaxonomyByOwner("prompt", auth.user.uid);

  if (promptsStatus === "loading" || bridgingStatus === "loading") {
    return <CircularProgress />;
  }
  if (!prompts) return null;

  // Build a map from prompt.id => array of tag names
  const promptTagsMap = {};
  if (bridging) {
    bridging.forEach((row) => {
      const arr = promptTagsMap[row.entity_id] || [];
      // row.taxonomy is { name: "theTagName" }
      arr.push(row.taxonomy.name);
      promptTagsMap[row.entity_id] = arr;
    });
  }

  return (
    <TableContainer component={Paper} style={{ marginTop: "2rem" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Default Model</TableCell>
            <TableCell>Content</TableCell>
            <TableCell>Tags</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {prompts.map((prompt) => {
            const tags = promptTagsMap[prompt.id] || [];
            return (
              <TableRow key={prompt.id}>
                <TableCell>{prompt.title}</TableCell>
                <TableCell>{prompt.default_model_name || "—"}</TableCell>
                <TableCell>{prompt.content}</TableCell>
                <TableCell>{tags.join(", ")}</TableCell>
                <TableCell>{prompt.createdAt}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ListPrompts;
